import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, { type JiraFavouriteFilter } from './__generated__/StarredMenuQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	filter: JiraFavouriteFilter;
	count: number;
};

export const sidebarStarredMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-nav4-sidebar-starred-menu" */ './StarredMenu.tsx'),
	),
	getPreloadProps: ({ cloudId, filter, count }: EntryPointParams) => ({
		queries: {
			starredMenuData: {
				parameters,
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				variables: {
					cloudId,
					count,
					filter,
				},
			},
		},
	}),
});
